import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HomeProvider } from "./context/Home_context";
import { AboutProvider } from "./context/About_context";
import { FormProvider } from "./context/Form_context";
import { BasicProvider } from "./context/Basic_context";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <HomeProvider>
      <BasicProvider>
        <AboutProvider>
          <FormProvider>
            <App />
          </FormProvider>
        </AboutProvider>
      </BasicProvider>
    </HomeProvider>
  </HelmetProvider>,
);
